<script setup>
definePageMeta({
  middleware: ['not-authenticated'],
})

const { forgotPassword } = useStrapiAuth()

const form = ref({
  email: '',
})
const message = ref('')
const messageType = ref('warning')
const success = ref(false)

async function submit() {
  try {
    await forgotPassword(form.value)
    success.value = true
  } catch ({ error }) {
    messageType.value = 'error'
    if (error && error.message) {
      message.value = error.message
    } else {
      message.value = 'Er is een fout opgetreden.'
    }
  }
}
</script>

<template>
  <div class="min-h-area py-20">
    <Container>
      <div class="mx-auto max-w-sm">
        <form @submit.prevent="submit">
          <div
            class="rounded-lg border border-gray-200 bg-white p-10 shadow-md shadow-gray-300"
          >
            <div v-if="success">
              <h1
                class="mb-6 text-center text-7xl font-black uppercase text-secondary"
              >
                Check je inbox
              </h1>

              <p class="text-gray-600">
                We hebben je instructies gestuurd om je nieuwe wachtwoord in te
                stellen
              </p>
            </div>

            <div v-else>
              <h1
                class="mb-6 text-center text-7xl font-black uppercase text-secondary"
              >
                Wachtwoord vergeten
              </h1>

              <div class="mb-4">
                <Input
                  v-model="form.email"
                  class="mb-2"
                  placeholder="Emailadres"
                  value=""
                />
              </div>

              <Notice
                v-if="message"
                :type="messageType"
                class="mb-4"
                @close="message = ''"
              >
                {{ message }}
              </Notice>

              <div>
                <Button
                  theme="primary"
                  text="Nieuw wachtwoord aanvragen"
                  size="md"
                  class="mb-4 w-full"
                  type="submit"
                />

                <div class="text-center">
                  <span class="text-gray-600">Nog geen account?</span>
                  <NuxtLink :to="{ name: 'register' }" class="text-secondary"
                    >Registreer hier</NuxtLink
                  >
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Container>
  </div>
</template>
